/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldNumberSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldNumberSmall',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 13 * scale,
      viewBox: '0 0 15 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M13.542 5 14 3h-2.364L12 1h-2l-.364 2h-3L7 1H5l-.364 2H2.458L2 5h2.273l-.546 3h-2.27L1 10h2.364L3 12h2l.364-2h3L8 12h2l.364-2h2.178L13 8h-2.273l.545-3zM8.727 8h-3l.545-3h3z"}))
}
